import axios from "../../../utils/request"
function GET_LIST(params) {
    return axios.get("/customer/ACustomer/index", {
        params: {
            ...params
        }
    })
}
function ADD_DATA(params) {
    return axios.get("/customer/ACustomer/add", {
        params: {}
    })
}
function EDIT_DATA(params) {
    return axios.get("/customer/ACustomer/edit", {
        params: {id: params}
    })
}
function SUBMIT_ADD(params) {
    return axios.post("/customer/ACustomer/addPost", {...params})
}
function SUBMIT_EDIT(params) {
    return axios.post("/customer/ACustomer/editPost", {...params})
}
function GET_PASSWORD(params) {
    return axios.get("/customer/ACustomer/randomPassword", {
        params: {}
    })
}
function CHANG_CHAT_STATUS(params) {
    return axios.post("/customer/ACustomer/editChatGptStatus", {...params})
}
function GET_JURISDICTION(params) {
    return axios.get("/customer/ACustomer/authorize", {
        params: {
            id: params
        }
    })
}
function SUBMIT_JURISDICTION(params) {
    return axios.post("/customer/ACustomer/authorizePost", {...params})
}
function OPEN_EDIT_DATA(params) {
    return axios.get("customer/ACustomer/openCustomers", {
        params: {id: params}
    })
}
function OPEN_DUE_DATE(params) {
    return axios.get("customer/ACustomer/getExpireDate", {
        params: {...params}
    })
}
function FB_EXIST_CUSTOMER(params) {
    return axios.get("customer/ACustomer/fbExistCustomer", {
        params: {...params}
    })
}
function CUSTOMER_SUBMIT_ADD(params) {
    return axios.post("customer/ACustomer/openCustomersPost", {...params})
}
function EXPORT(params) {
    return axios.get("/customer/ACustomer/exportCustomer", {
        params: {
            ...params
        }
    })
}
function BAOTA(params) {
    return axios.get("/customer/ACustomer/onlineWebsite", {
        params: {
            ...params
        }
    })
}
function SITEMAP(params) {
    return axios.post("/customer/ACustomer/createSitemap", {
        ...params
    })
}
function BAOTASSL(params) {
    return axios.get("/customer/ACustomer/setCustomerSSL", {
        params: {
            ...params
        }
    })
}
function CHANGE_TRANSLATION_NUM(params) {
    return axios.get("/customer/ACustomer/changeTranslationNum", {
        params: {
            ...params
        }
    })
}
function CHANGE_TRANSLATION_NUM_POST(params) {
    return axios.post("/customer/ACustomer/changeTranslationNumPost", {...params})
}
function CHANG_ONLINE(params) {
    return axios.post("/customer/ACustomer/getAutomatedMarketingExpireTime", {...params})
}
function GET_INDUSTRY_LIST(params) {
    return axios.get("/customer/ACustomer/getIndustryList", {
        params: {
            ...params
        }
    })
}
function OPEN_CHAT_GPT_STATUS(params) {
    return axios.post("/customer/ACustomer/openChatGptStatus", {...params})
}
function CLOSE_CHAT_GPT_STATUS(params) {
    return axios.post("/customer/ACustomer/closeChatGptStatus", {...params})
}
function LOADING_NGINX_CONFIG(params) {
    return axios.get("/customer/ACustomer/loadingNginxConfig", {
        params: {
            ...params
        }
    })
}
// 关联站长工具账号下拉数据
function GET_GOOGLE_SEARCH_CONSOLE(params) {
    return axios.get("/customer/AGoogleSearchConsole/getGoogleSearchConsole", {
        params: {
            ...params
        }
    })
}
// 关联站长工具账号提交
function BINDING_ACCOUNT(params) {
    return axios.post("/customer/AGoogleSearchConsole/bindingAccount", {...params})
}
// 批量生成sitemap
function BARCH_CREATE_SITMAP(params) {
    return axios.post("/customer/ACustomer/batchCreateSitemap", {...params})
}
// 关联站长工具账号网域验证弹框信息
function GET_CUSTOMER_LIST(params) {
    return axios.get("/customer/AGoogleSearchConsole/getCustomerList", {
        params: params
    })
}
// 关联站长工具账号提交验证
function SITES_VERIFY(params) {
    return axios.post("/customer/AGoogleSearchConsole/sitesVerify", {...params})
}

function OPEN_SITEMAP(params) {
    return axios.post("/customer/ACustomer/openSitemap", {...params})
}

function OPEN_ROBOTS(params) {
    return axios.post("/customer/ACustomer/openRobots", {...params})
}
export default {
    OPEN_CHAT_GPT_STATUS, CLOSE_CHAT_GPT_STATUS, CHANG_CHAT_STATUS,
    CHANG_ONLINE,
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    GET_PASSWORD,
    // CHANG_STATUS,
    GET_JURISDICTION,
    SUBMIT_JURISDICTION,
    OPEN_EDIT_DATA,
    OPEN_DUE_DATE,
    FB_EXIST_CUSTOMER,
    CUSTOMER_SUBMIT_ADD,
    EXPORT, BAOTA, BAOTASSL, CHANGE_TRANSLATION_NUM, CHANGE_TRANSLATION_NUM_POST, SITEMAP, GET_INDUSTRY_LIST,
    LOADING_NGINX_CONFIG,
    GET_GOOGLE_SEARCH_CONSOLE,
    BINDING_ACCOUNT,
    BARCH_CREATE_SITMAP,
    GET_CUSTOMER_LIST,
    SITES_VERIFY,OPEN_SITEMAP,OPEN_ROBOTS
}
